
















export const ACPermissionActionArray = ['read', 'create', 'update', 'delete'];

export var ACPermissionResult; (function (ACPermissionResult) {
  const ALLOW = 0; ACPermissionResult[ACPermissionResult["ALLOW"] = ALLOW] = "ALLOW";
  const DENY = ALLOW + 1; ACPermissionResult[ACPermissionResult["DENY"] = DENY] = "DENY";
})(ACPermissionResult || (ACPermissionResult = {}));
